import { render } from "./NavTabs.vue?vue&type=template&id=19ddafe6&scoped=true"
import script from "./NavTabs.vue?vue&type=script&lang=js"
export * from "./NavTabs.vue?vue&type=script&lang=js"

import "./NavTabs.vue?vue&type=style&index=0&id=19ddafe6&scoped=true&lang=css"

import exportComponent from "/var/www/compare-loans.org/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ddafe6"]])

export default __exports__